import * as Colors from "@mui/material/colors"
import makeStyles from "@mui/styles/makeStyles"
import { FormattedMessage, useIntl } from "react-intl"
import { useAuth } from "react-oidc-context"
import { useDispatch, useSelector } from "react-redux"
import { logIn } from "../../actions/authentication"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import { PlaneusCompleteLogo } from "../../theme/Planeus"
import Form from "./Form"

const isSSOCustomer = process.env.REACT_APP_SSOCUSTOMER === "true"

const useStyles = makeStyles({
  form: {
    width: "30%",
    height: "30%",
  },
  header: {
    margin: "8px",
  },
  error: {
    backgroundColor: Colors.red.A700,
    marginTop: 24,
    borderRadius: 8,
    color: "white",
    padding: 16,
  },
  logo: {
    width: "80%",
    marginBottom: 48,
  },
})

function getLoginError(message) {
  switch (message) {
    case "Invalid username or password":
      return <FormattedMessage id="pages.login.errors.wrongCredentials" />
    case "InvalidUserNameOrPassword":
      return <FormattedMessage id="pages.login.errors.wrongCredentials" />
    case "NumberOfLoginAttemptsExceeded":
      return <FormattedMessage id="pages.login.errors.numberOfLoginAttemptsExceeded" />
    default:
      return <FormattedMessage id="errors.API.500" />
  }
}

const Login = () => {
  const classes = useStyles()
  const authentication = useSelector(state => state.user.authentication)
  const dispatch = useDispatch()
  const { loginError } = authentication

  const auth = useAuth()
  const intl = useIntl()

  const handleSubmit = values => {
    const { username, password } = values
    if (username && password) {
      dispatch(logIn(username, password, auth))
    }
  }

  useDocumentTitle(intl.formatMessage({ id: "modules.login" }))
  return (
    <div>
      <PlaneusCompleteLogo className={classes.logo} />
      <Form onSubmit={handleSubmit} isPending={false} isSSOCustomer={isSSOCustomer} onLoginSSO={auth.signinRedirect} />
      {loginError && <div className={classes.error}>{getLoginError(loginError.message, auth)}</div>}
    </div>
  )
}

export default Login
